import { getGroupHierarchyIds } from "./groupHierarchy.util";

const getGroupIdsWithHierarchy = (groupId, groupLookup) => {
  const groupIds = getGroupHierarchyIds(groupLookup[groupId]);
  groupIds.reverse();

  if (groupId) {
    groupIds.unshift(groupId);
  }

  return groupIds.filter(Boolean);
};

const getSourceAndTargetGroupIds = ({ data, groupLookup = {} }) => {
  const { sourceGroupId, targetGroupId } = data;

  return {
    sourceGroupIds: getGroupIdsWithHierarchy(sourceGroupId, groupLookup),
    targetGroupIds: getGroupIdsWithHierarchy(targetGroupId, groupLookup),
  };
};

export const getMatchingCell = ({ data, cellLookup, groupLookup }) => {
  const { id, dateRangeId } = data;
  const directCellId = `macro-allocation-${id}`;

  if (cellLookup[directCellId]) {
    return cellLookup[directCellId];
  }

  const { sourceGroupIds, targetGroupIds } = getSourceAndTargetGroupIds({
    data,
    groupLookup,
  });

  for (const candidateSourceGroupId of sourceGroupIds) {
    for (const candidateTargetGroupId of targetGroupIds) {
      const cellId = `macro-allocation-${dateRangeId}-${candidateSourceGroupId}-${candidateTargetGroupId}`;

      if (cellLookup[cellId]) {
        return cellLookup[cellId];
      }
    }
  }

  return null;
};
